import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton, ContenedorSelect, ContenedorGrupoSelect, ContenedorInputsObjeto, ContenedorInputsObjetoUnidad} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import SelectAutor from './SelectAutor';
import SelectTipoPublicacion from './SelectTipoPublicacion';
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import {useAuth} from "./../contextos/AuthContext";
import { useNavigate } from "react-router-dom";

const FormularioPublicacion = ({publicacion}) => {
    const {idUsuario} = useAuth();

    const [inputTitulo, setInputTitulo] = useState('');
    const [inputAnio, setInputAnio] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [inputRutaPDF, setInputRutaPDF] = useState(null);
    const [PDFEliminar, setPDFEliminar] = useState(null);
    const [selectAutor, setSelectAutor] = useState([])
    const [selectAutorActive, setSelectAutorActive] = useState(false)
    const [selectTipoPublicacion, setSelectTipoPublicacion] = useState([])
    const [selectTipoPublicacionActive, setSelectTipoPublicacionActive] = useState(false)
    const [estadoAlerta, setEstadoAlerta] = useState(false)
    const [alerta, setAlerta] = useState({})
    const navigate = useNavigate()

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(publicacion){
            setInputTitulo(publicacion.Pub_Titulo);
            setInputAnio(publicacion.Pub_Anio);
            setInputRutaPDF(publicacion.Pub_RutaArchivo);
            setPDFEliminar(publicacion.Pub_RutaArchivo);
            setSelectAutor({Aut_ID:publicacion.Aut_ID, Aut_Nombre:publicacion.Aut_Nombre});
            setSelectTipoPublicacion({TPub_ID:publicacion.TPub_ID, TPub_Nombre:publicacion.TPub_Nombre});
        }
    }, [publicacion]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'titulo':
                setInputTitulo(e.target.value);
                break;
            case 'anio':
                setInputAnio(e.target.value);
                break;
            case 'pdf':
                setInputRutaPDF(e.target.files[0].name);
                setSelectedFile(e.target.files[0]);
                break;
            default:
                break;
        }
    }



    const offSelectTipoPublicacion = () => {
        setSelectAutorActive(!selectAutorActive)
        setSelectTipoPublicacionActive(false)
    }

    const offSelectAutor = () => {
        setSelectTipoPublicacionActive(!selectTipoPublicacionActive)
        setSelectAutorActive(false)
    }

    const almacenarPDF = () => {
        const formdata = new FormData()
        formdata.append('pdf', selectedFile)
        console.log(selectedFile)

        fetch(Api+"?subirPDF", {
            method: "POST",
            body: formdata
        })
        .then((response) => response.json())
        .then((data) => {
          // Procesar la respuesta del servidor
          console.log(data);
        })
        .catch((error) => {
            // Manejar errores
            console.error(error);
        })
    }

    const actualizarPDF = () => {
        const formdata = new FormData()
        formdata.append('pdf', selectedFile)
        console.log(selectedFile)

        fetch(Api+"?actualizarPDF="+publicacion.Pub_ID, {
            method: "POST",
            body: formdata
        })
        .then((response) => response.json())
        .then((data) => {
          // Procesar la respuesta del servidor
          console.log(data);
        })
        .catch((error) => {
            // Manejar errores
            console.error(error);
        })
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputTitulo === '' || inputAnio === '' || inputRutaPDF === null || selectAutor.Aut_ID === 0 || selectTipoPublicacion.TPub_ID === 0 ){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!publicacion){
            datosEnviar = {titulo:inputTitulo, anio:inputAnio, pdf:inputRutaPDF, idAutor:selectAutor.Aut_ID, idTipoPublicacion:selectTipoPublicacion.TPub_ID, idUser:idUsuario}
            console.log(datosEnviar)
            fetch(Api+"?insertarPublicacion",{
                method:"POST",
                body: JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(datosRespuesta.success === 1){
                    if(selectedFile){
                        almacenarPDF();
                    }
                    
                    setInputTitulo('');
                    setInputAnio('');
                    setInputRutaPDF(null);
                    setSelectAutor({Aut_ID:0, Aut_Nombre: 'Seleccione Autor'});
                    setSelectTipoPublicacion({TPub_ID:0, TPub_Nombre: 'Seleccione Tipo de Publicación'});
                    document.getElementById('inputFile').value = null;
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: 'Publicación registrada correctamente.'
                    });
                    
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: 'Error al agregar publicación.'
                    });
                }
                
            })
            .catch(console.log)
        }
        else{
            datosEnviar = {id:publicacion.Pub_ID, titulo:inputTitulo, anio:inputAnio, PDF:inputRutaPDF, PDFEliminar:PDFEliminar, idAutor:selectAutor.Aut_ID, idTipoPublicacion:selectTipoPublicacion.TPub_ID, idUser:idUsuario}
            console.log(datosEnviar)
            fetch(Api+"?actualizarPublicacion",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(selectedFile){
                    actualizarPDF();
                }
                navigate("/publicaciones");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Título</Etiqueta>
                    <Input
                        type="text"
                        name="titulo"
                        placeholder="Ingrese Título"
                        value={inputTitulo}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Año</Etiqueta>
                    <Input
                        type="text"
                        name="anio"
                        placeholder="Ingrese Año"
                        value={inputAnio}
                        onChange={handleChange}
                    />
                </div>
                
                <ContenedorGrupoSelect>
                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Autor</Etiqueta>
                        <SelectAutor
                            selectAutor={selectAutor}
                            setSelectAutor={setSelectAutor}
                            mostrarSelect={selectAutorActive}
                            desactivarSelects={offSelectTipoPublicacion}
                        />
                    </ContenedorSelect>

                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Tipo de Publicación</Etiqueta>
                        <SelectTipoPublicacion
                            selectTipoPublicacion={selectTipoPublicacion}
                            setSelectTipoPublicacion={setSelectTipoPublicacion}
                            mostrarSelect={selectTipoPublicacionActive}
                            desactivarSelects={offSelectAutor}
                        />
                    </ContenedorSelect>
                </ContenedorGrupoSelect>

                <Etiqueta htmlFor="">PDF: {inputRutaPDF}</Etiqueta>
                <input 
                    type="file"
                    name="pdf"
                    id="inputFile"
                    onChange={handleChange}/>

                <ContenedorBoton>
                        <Boton to="/objetos">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {publicacion ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioPublicacion;